export enum WidgetKey {
  HR_VACANCIES = 'hrVacanciesWidget',
  REPORT = 'reportWidget',
}